import { PortalModule } from "@/@core";

import "./components";
import "./modal";
import "./snackbar";
import "./tracking";

import Forbidden from "@/@shell/views/Forbidden.vue";
import Maintenance from "@/@shell/views/Maintenance.vue";

export { default as App } from "@/@shell/components/App.vue";

export const module = {
  name: "shell",
  routes: [
    {
      path: "/forbidden",
      component: Forbidden,
      auth: { allowAnonymous: true },
    },
    {
      path: "/maintenance",
      component: Maintenance,
      auth: { allowAnonymous: true },
    },
  ],
} as PortalModule;
